module.exports = __webpack_public_path__ + "img/km_14.122b5cdb.jpeg";